
import ReactDOM from 'react-dom/client';
import { MotoclickApp } from './MotoclickApp';
import './styles/styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MotoclickApp/>
);
